import { render, staticRenderFns } from "./chihongimportform.vue?vue&type=template&id=7621f840&scoped=true&"
import script from "./chihongimportform.vue?vue&type=script&lang=js&"
export * from "./chihongimportform.vue?vue&type=script&lang=js&"
import style0 from "./chihongimportform.vue?vue&type=style&index=0&id=7621f840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7621f840",
  null
  
)

export default component.exports